var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "External link"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3C10.9477 3 10.5 3.44772 10.5 4C10.5 4.55228 10.9477 5 11.5 5H14.0858L7.79289 11.2929C7.40237 11.6834 7.40237 12.3166 7.79289 12.7071C8.18342 13.0976 8.81658 13.0976 9.20711 12.7071L15.5 6.41421V9C15.5 9.55228 15.9477 10 16.5 10C17.0523 10 17.5 9.55228 17.5 9V4C17.5 3.44772 17.0523 3 16.5 3H11.5Z",
    fill: "#2E8FFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5C4.39543 5 3.5 5.89543 3.5 7V15C3.5 16.1046 4.39543 17 5.5 17H13.5C14.6046 17 15.5 16.1046 15.5 15V12C15.5 11.4477 15.0523 11 14.5 11C13.9477 11 13.5 11.4477 13.5 12V15H5.5V7L8.5 7C9.05228 7 9.5 6.55228 9.5 6C9.5 5.44772 9.05228 5 8.5 5H5.5Z",
    fill: "#2E8FFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.29bae985733ee2882e704c7bbdbfb4ac.svg";
export { ForwardRef as ReactComponent };